import { render, staticRenderFns } from "./SearchList.vue?vue&type=template&id=54ba82fe&"
import script from "./SearchList.vue?vue&type=script&lang=js&"
export * from "./SearchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports